export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"name":"apple-itunes-app","content":"app-id=1587589957"},{"hid":"og:site_name","property":"og:site_name","content":"Betway"},{"hid":"og:image","property":"og:image","content":"/betway.png"},{"name":"msapplication-TileColor","content":"#000000"},{"name":"theme-color","content":"#000000"}],"link":[{"rel":"stylesheet","crossorigin":"anonymous","href":"https://cdn.betwayafrica.com/Global/fonts/roboto/roboto.css"},{"rel":"stylesheet","crossorigin":"anonymous","href":"https://cdn.betwayafrica.com/Global/fonts/BigShouldersDisplay/bigshoulders.css"},{"rel":"apple-touch-icon","sizes":"180x180","href":"https://cms1.betwayafrica.com/medialibraries/content.gmgamingsystems.com/Synapse/v2/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"https://cms1.betwayafrica.com/medialibraries/content.gmgamingsystems.com/Synapse/v2/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"https://cms1.betwayafrica.com/medialibraries/content.gmgamingsystems.com/Synapse/v2/favicon-16x16.png"},{"rel":"manifest","href":"/site.webmanifest"},{"rel":"mask-icon","href":"https://cms1.betwayafrica.com/medialibraries/content.gmgamingsystems.com/Synapse/v2/safari-pinned-tab.svg","color":"#000000"}],"style":[],"script":[{"src":"https://cdn.betwayafrica.com/BWA/hammer.min.js"}],"noscript":[],"title":"Betway"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const devPagesDir = null

export const devRootDir = null